import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "opacity"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#opacity" }),
  /*#__PURE__*/_createTextVNode(" Opacity ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".opacity-{0, 5, 10, 15, 20, 25, 50, 75, 100}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's opacity: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10 d-flex flex-wrap" }
const _hoisted_6 = { class: "fw-bold py-2" }
const _hoisted_7 = { class: "py-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="opacity-0"></div>
        <div class="opacity-5"></div>
        <div class="opacity-10"></div>
        <div class="opacity-15"></div>
        <div class="opacity-20"></div>
        <div class="opacity-25"></div>
        <div class="opacity-50"></div>
        <div class="opacity-75"></div>
        <div class="opacity-100"></div>
        `))
const _hoisted_9 = { class: "pt-10" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "opacity-hover"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#opacity-hover" }),
  /*#__PURE__*/_createTextVNode(" Opacity Hover ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".opacity-{0, 5, 10, 15, 20, 25, 50, 75, 100}-hover"),
  /*#__PURE__*/_createTextVNode(" class to set an element's opacity on hover: ")
], -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = { class: "rounded border p-10 d-flex flex-wrap" }
const _hoisted_14 = { class: "fw-bold py-2" }
const _hoisted_15 = { class: "py-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="opacity-hover-0"></div>
        <div class="opacity-hover-5"></div>
        <div class="opacity-hover-10"></div>
        <div class="opacity-hover-15"></div>
        <div class="opacity-hover-20"></div>
        <div class="opacity-hover-25"></div>
        <div class="opacity-hover-50"></div>
        <div class="opacity-hover-75"></div>
        <div class="opacity-hover-100"></div>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.opacityValues, (value, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: "d-flex flex-column me-5 mb-5"
            }, [
              _createVNode("div", {
                class: [`opacity-${value}`, "w-90px h-90px bg-dark flex-grow-1"]
              }, null, 2),
              _createVNode("div", _hoisted_6, "opacity-" + _toDisplayString(value), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_CodeHighlighter, { lang: "html" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _hoisted_10,
      _hoisted_11,
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.opacityValues, (value, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: "d-flex flex-column me-5 mb-5"
            }, [
              _createVNode("div", {
                class: [`opacity-${value}-hover`, "w-100px h-100px bg-dark flex-grow-1 opacity-100"]
              }, null, 2),
              _createVNode("div", _hoisted_14, "opacity-" + _toDisplayString(value) + "-hover", 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_CodeHighlighter, { lang: "html" }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}